import { fmt } from '@/lib/format';

const PERCENT_FORMATTER = new Intl.NumberFormat('fa-IR', {
    maximumFractionDigits: 3,
});
const INTEGER_FORMATTER = new Intl.NumberFormat('fa-IR', {
    maximumFractionDigits: 0,
});

export const formatPercent = (value) => `${PERCENT_FORMATTER.format(Number(value))}٪`;
export const formatRial = (value) => `${fmt(value)} ریال`;
export const formatNumber = (value) => INTEGER_FORMATTER.format(value);
export const nodeLabel = (index) => String.fromCharCode(65 + index);